import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { IHomeCategoryProps } from "../../models/interface";
import { IconArrow, IconClose } from "../images";
import HomeCategoryItem from "./homeCategoryItem";
import "./style.scss";
import _ from "lodash";
import { selectHeaderCategories } from "../../redux/reducers/slice/common";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import { COLORS } from "../../common/constant";
import { IVoucherInfo } from "../../models/interface/IVoucherInfo";
import { getVoucherInfo } from "../../utils/helpers";
import { Button } from "antd";

const Category = (props: IHomeCategoryProps) => {
  const { history, location } = props;
  const { t } = useTranslation();
  const headerCategories = useSelector(selectHeaderCategories);
  const _categories =
    headerCategories &&
    headerCategories.header_category_id &&
    headerCategories.header_category_id.length
      ? _.sortBy(
          headerCategories.header_category_id.filter(
            (x) => x.is_actived && x.is_parent
          ),
          ["order"]
        )
      : [];
  const control: any = useRef();
  let slider: any = useRef();
  const [visibleArrowLeft, setVisibleArrowLeft] = useState(true);
  const [visibleArrowRight, setVisibleArrowRight] = useState(true);
  const [slug, setSlug] = useState("");
  const [initialSlide, setInitialSlide] = useState(0);
  const [showVoucher, setShowVoucher] = React.useState(true);
  const { innerWidth } = window;

  const colorStyle: ISectionCSS = {
    "--backgroundColor": headerCategories
      ? headerCategories.background_color
      : COLORS.WHITE,
    "--colorTitle": headerCategories
      ? headerCategories.color_title
      : COLORS.GRAY_LIGHT,
    "--color": headerCategories ? headerCategories.color : COLORS.BLUE_DARK,
  };

  useEffect(() => {
    if (!headerCategories) {
      const paths = history.location.pathname.split("/");
      getInitialSlide("/" + paths[paths.length - 1]);
    }
  }, []);

  useEffect(() => {
    const paths = history.location.pathname.split("/");
    setSlug("/" + paths[paths.length - 1]);
  }, [history.location.pathname]);

  const getInitialSlide = (_slug: string) => {
    switch (_slug) {
      case t("routes.category_nem"):
        setInitialSlide(1);
        break;
      case t("routes.category_goi"):
        if (innerWidth > 630) {
          setVisibleArrowRight(false);
        }
        setInitialSlide(2);
        break;
      case t("routes.category_ga"):
        if (innerWidth > 630) {
          setVisibleArrowRight(false);
        }
        setInitialSlide(3);
        break;
      case t("routes.category_giuong"):
        setVisibleArrowRight(false);
        setInitialSlide(4);
        break;
      case t("routes.category_sofa"):
        setVisibleArrowRight(false);
        setInitialSlide(5);
        break;
      case t("routes.category_vo-boc-nem"):
      case t("routes.category_tam-an-toan-ve-sinh-nem"):
      case t("routes.category_ruot-men"):
        setVisibleArrowRight(false);
        setInitialSlide(6);
        break;
      default:
        setVisibleArrowLeft(false);
        setInitialSlide(0);
        break;
    }
  };

  const showSlide = () => {
    if ([4, 5, 6].includes(initialSlide)) {
      return innerWidth > 630 ? 2 : 4;
    }
    if (initialSlide === 3 && innerWidth > 630) {
      return 2;
    }
    return initialSlide;
  };

  const settings = {
    initialSlide: showSlide(),
    dots: false,
    infinite: false,
    arrows: false,
    accessibility: true,
    speed: 500,
    slidesToShow: _categories.length,
    // ? _categories.length > 6
    //   ? 7
    //   : _categories.length
    // : 7,
    slidesToScroll: 1,
    beforeChange: (current: any, next: any) => {
      if (next + (innerWidth > 630 ? 5 : 3) === _categories?.length) {
        setVisibleArrowRight(false);
      } else {
        setVisibleArrowRight(true);
      }

      if (next) {
        setVisibleArrowLeft(true);
      } else {
        setVisibleArrowLeft(false);
      }
    },
    responsive: [
      {
        breakpoint: 630,
        settings: {
          slidesToShow: _categories
            ? _categories.length > 3
              ? 3
              : _categories.length
            : 3,
        },
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: _categories
            ? _categories.length > 5
              ? 5
              : _categories.length
            : 5,
        },
      },
    ],
  };

  const voucherInfo = () => {
    const voucherInfo: IVoucherInfo = getVoucherInfo();
    if (!voucherInfo || !voucherInfo.code || !showVoucher) return;

    return (
      <div className="voucher-info">
        <span>
          Xin lưu ý: Giao diện website đang hiển thị được áp dụng ưu đãi đặc
          biệt dành riêng cho Quý khách.
        </span>
        <Button
          className="voucher-close"
          onClick={() => setShowVoucher(!showVoucher)}>
          <img src={IconClose} />
        </Button>
      </div>
    );
  };

  return (
    <div className="kd-home-category-wrapper" ref={control} style={colorStyle}>
      {voucherInfo()}
      <div className="home-categories">
        {visibleArrowLeft ? (
          <a className="kd-btn-arrow-left" onClick={() => slider.slickPrev()}>
            <img src={IconArrow} style={{ width: 25 }} alt="Prev" />
          </a>
        ) : null}
        {_categories && _categories.length ? (
          <Slider
            {...settings}
            ref={(c) => (slider = c)}
            className="kd-category-slider">
            {_categories?.map((v, i) => (
              <div
                key={i}
                className={
                  // slug === "/" && v.slug === "home"
                  t(`routes.${v.slug}`) === slug
                    ? "category-active"
                    : t(`routes.category_${v.slug}`) === slug ||
                      v?.header_ids.filter(
                        (h: any) => h.slug === slug.split("/")[1]
                      ).length
                    ? "category-active"
                    : ""
                }>
                <HomeCategoryItem
                  category={v}
                  history={props.history}
                  location={location}
                  slug={slug}
                />
              </div>
            ))}
          </Slider>
        ) : null}
        {visibleArrowRight ? (
          <a className="kd-btn-arrow-right" onClick={() => slider.slickNext()}>
            <img
              src={IconArrow}
              style={{ width: 25, transform: "scaleX(-1)" }}
              alt="Next"
            />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default Category;
